<template>
    <form action="#" method="POST" class="" @submit.prevent="emit('submit', metaForm)">
        <input type="hidden" id="meta_data_type" name="meta_data_type" v-model="metaForm.metaDataType" />
        <div class="grid grid-cols-6 gap-3">
            <div class="col-span-6">
                <label for="company" class="block text-sm font-medium text-gray-700">{{ t('setMetaData.body:metaNameLabel') }}</label>
                <div class="relative">
                    <input v-model="metaForm.name" id="name" name="name" type="text" :placeholder="t('setMetaData.body:metaNamePlaceholder')" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="metaForm.errors.name">
                        <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                    </div>
                </div>
                <p class="mt-2 text-sm text-red-600" id="company-error" v-if="metaForm.errors.name">{{metaForm.errors.name}}</p>
            </div>
            <div class="col-span-6">
                <label for="line1" class="block text-sm font-medium text-gray-700">{{ t('setMetaData.body:metaDescriptionLabel') }}</label>
                <div class="relative">
                    <textarea :placeholder="t('setMetaData.body:metaDescriptionPlaceholder')" v-model="metaForm.description" id="description" name="description" rows="5" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"></textarea>
                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="metaForm.errors.description">
                        <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                    </div>
                </div>
                <p class="mt-2 text-sm text-red-600" id="description-error" v-if="metaForm.errors.description">{{metaForm.errors.description}}</p>
            </div>
            <div class="col-span-6">
                <p class="text-xs text-gray-500">{{ t('setMetaData.body:metaInfoText') }}</p>
            </div>
        </div>
    </form>
</template>

<script setup>

import {useForm, usePage} from "@inertiajs/inertia-vue3";
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid'
import translate from "../../../lang";

const props = defineProps({
    nft: Object
});

const emit = defineEmits(['submit']);

const metaForm = useForm({
    name: props.nft.metaName,
    description: props.nft.metaDescription,
    fields: props.nft.metaFields
});
const t = translate('upload-' + props.nft.metaDataType);

defineExpose({form: metaForm});

</script>
